
import {initWebComponent} from "@/helpers/web-component-helper"
import {resetMutation, setMutationSettings} from "@/helpers/tools/tools-mutation-helper"
import {
    getBySelector,
    hideElementsBySelector,
    removeClassBySelector,
    showElementsBySelector
} from "@/helpers/element-helper"
import $ from "jquery"
import {stopDraw} from "@/helpers/ol/draw/ol-draw-polygon-helper"

export class LayerInfoToolsMutationComponent extends HTMLElement {
    constructor(){
        super();

        let showClass = 'd-none'
        if(window.settings.ShowAllMutations === 2) {
            showClass = ''
        }

        const template = document.createElement('template');
        template.innerHTML = `
             <div class="card-body pl-2 pr-2 ${showClass}"  id="divCardMutationLayers">
                <div class="row mt-4">
                    <div class="col-12">
                        <span id="tblMutationSettings_clear" class="fa fa-times position-absolute cursor-pointer d-none" style="right: 25px;top: -11px;z-index: 100;font-size:10px">
                        </span>
                        <table id="tblMutationSettings" style="width: 100%" class="nowrap table table-hover dataTable no-footer">
                            <thead>
                                <tr>
                                    <th>Naam</th>
                                </th>
                            </thead>
                            <tbody></tbody>
                         </table>
                      <select size="1" class="custom-select d-none" id="slcMutationLayers">
                       </select>
                   </div>
                </div>
            </div>
            <div class="nav nav-tabs scrollmenu mb-2" id="divMutationLayers">
            </div>
            <button id="btnShowMutationLayers" class="btn d-none btn-outline-secondary btn-sm borderless float-right mr-2" style="margin-top: -35px;">
                <span class="fa fa-chevron-left"></span> Muteren
            </button>
            <div id="divToolsMutationSettings"></div>
        `;

        console.log('component')

        initWebComponent(this, template)

        document.getElementById('btnShowMutationLayers').addEventListener('click', () => {
            resetMutation()
        })

        this.querySelector('#divMutationLayers').addEventListener('click', (event) => {
            if(event.target.tagName === 'A') {
                removeClassBySelector('.nav-link-mutation-header', 'active')
                event.target.classList.add('active')

                const element = event.target.dataset

                // const mutationForm = window.mutationForms.find(mutationForm => mutationForm.ID === parseInt(event.target.dataset.id))

                setMutationSettings(element.bookmarkPresentationId, element.domainId, element.presentationId, element.formId)
            }
        })

        if(!window.chrome) {
            this.querySelector('#tblMutationSettings_clear').addEventListener('click', (event) => {
                window['tblMutationSettings'].search('').draw();
                hideElementsBySelector('#tblMutationSettings_clear')
            })
        }
    }
}

